import React, { useCallback, forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { BasePrompt, PromptSubmitButton } from '../../../../../components';
import { usePromptHandlers } from '../../../hooks';
import {
  lexicalBeautifulMentionsTag,
  termTranslationShape,
  sourceShape
} from '../../../../../propsShape';

const StyledPromptSubmitButton = styled(PromptSubmitButton)`
  margin-left: auto;
`;

const AssetPrompt = forwardRef(
  (
    {
      handleCreateQuestion,
      mentionItems,
      termTranslations,
      actions = null,
      onFirstSubmit = null,
      disabled = false,
      className = null,
      sources,
      placeholder = 'What would you like to see?',
      insertMentionRef,
      matchingEntities = null,
      findEntityMatches = null,
      handleSelectEntity = null
    },
    editorRef
  ) => {
    const [prompt, setPrompt] = useState('');

    const { handleSubmit, handleKeyDown, handleOnChange } = usePromptHandlers({
      editorRef,
      onSubmit: handleCreateQuestion,
      onSetPrompt: setPrompt,
      onFirstSubmit
    });

    const renderSubmitButton = useCallback(
      () => (
        <StyledPromptSubmitButton
          disabled={prompt === ''}
          onClick={(evt) => handleSubmit(evt, prompt)}
        />
      ),
      [handleCreateQuestion, prompt, onFirstSubmit]
    );

    return (
      <BasePrompt
        className={className}
        ref={editorRef}
        insertMentionRef={insertMentionRef}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        onChange={handleOnChange}
        mentionItems={mentionItems}
        sources={sources}
        terms={termTranslations}
        renderSubmitButton={renderSubmitButton}
        disabled={disabled}
        actions={actions}
        handleSelectEntity={handleSelectEntity}
        findEntityMatches={findEntityMatches}
        matchingEntities={matchingEntities}
      />
    );
  }
);

AssetPrompt.propTypes = {
  handleCreateQuestion: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  handleSelectEntity: PropTypes.func,
  mentionItems: PropTypes.shape({
    columns: PropTypes.arrayOf(lexicalBeautifulMentionsTag),
    metrics: PropTypes.arrayOf(lexicalBeautifulMentionsTag)
  }).isRequired,
  termTranslations: PropTypes.arrayOf(termTranslationShape).isRequired,
  onFirstSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  actions: PropTypes.node,
  sources: PropTypes.arrayOf(sourceShape),
  insertMentionRef: PropTypes.shape({
    current: PropTypes.func
  }),
  findEntityMatches: PropTypes.func,
  matchingEntities: PropTypes.arrayOf(PropTypes.string)
};

export { AssetPrompt };
